export var CardStyleType;
(function (CardStyleType) {
    CardStyleType[CardStyleType["Normal"] = 1] = "Normal";
    CardStyleType[CardStyleType["RankPoi"] = 2] = "RankPoi";
    CardStyleType[CardStyleType["ThreeColumn"] = 3] = "ThreeColumn";
})(CardStyleType || (CardStyleType = {}));
export var COMMODITY_INFO_CONFIG;
(function (COMMODITY_INFO_CONFIG) {
    COMMODITY_INFO_CONFIG["ID_LIST"] = "idList";
    COMMODITY_INFO_CONFIG["PRODUCT_BATCH_DATA"] = "productBatchData";
    COMMODITY_INFO_CONFIG["SUPPLY_ID"] = "supplyId";
})(COMMODITY_INFO_CONFIG || (COMMODITY_INFO_CONFIG = {}));
